module.exports = __webpack_public_path__ + "static/media/whowearebgleft.baffa7b3.webp";